/* eslint-disable @typescript-eslint/no-shadow */
import angular from 'angular';
import { RootScope } from '../../app.config';
import { ConfigService } from '../../shared/config/config.service';
import { EBookableFeatures } from '../../src/app/@shared-types/tenant/enums';

export const TierComponent = {
  selector: 'tier',
  bindings: {
    features: '@',
  },
  transclude: true,
  template: /* html */ `
    <ng-transclude></ng-transclude>
  `,
  controller: class TierComponentController {
    private configService: ConfigService;

    private $rootScope: RootScope;

    private $element: JQLite;

    public features!: string;

    constructor(
      configService: ConfigService,
      $rootScope: RootScope,
      $element: JQLite,
    ) {
      'ngInject';

      this.configService = configService;
      this.$rootScope = $rootScope;
      this.$element = $element;

      this.$rootScope.$on('updateTierVisibility', () => {
        this.toggleVisibility();
      });

      this.toggleVisibility();
    }

    public $onInit = (): void => this.toggleVisibility();

    private toggleVisibility = () => {
      if (this.configService.get('featuresForTenant') && this.features) {
        const bookedFeatures = this.configService.get<EBookableFeatures[]>('featuresForTenant');
        if (!bookedFeatures) return;
        const featuresToCheck: EBookableFeatures[] = this.features.split(',') as unknown as EBookableFeatures[];

        const allowed = bookedFeatures.some((f) => featuresToCheck.includes(f));
        if (!allowed) this.$element.remove();
      }
    };
  },
};

/**
 * This directive can toggle the visibility of elements if the user is allowed to see them or not.
 * The `hasPermission` attribute defines `frontendAction`, which is assigned to roles.
 * After all permissions are received by the server,
 * all directives are called to validate the visibility.
 */
export default angular.module('services.tier', [])
  .component(TierComponent.selector, TierComponent)
  .name;
